import React, {useState, useEffect} from "react";
import Summary from '../components/game/mk-battle-summary-panel';
import Training from '../components/game/culinary-missions';
import ReadySetWhip from '../components/game/ready-set-whip-panel';
import BattleSchool from '../components/game/mk-battle-school';
import BattleKitchen from '../components/game/mk-battle-kitchen-panel';
import {gPageView} from "../google-analytics";
import SuperOGInfo from '../components/game/super-og-info';

function GamePage() {
    useEffect(() => {
        gPageView('game');
    }, );
    return (
        <div id="game-page" className="">
            <div className="panel bg-home">
                <SuperOGInfo />
                <Summary />
                <ReadySetWhip />
                <Training />
                <BattleSchool />
                <BattleKitchen />
            </div>
        </div>
    );
}

export default GamePage;